"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The StellenanzeigeCreate model module.
 * @module model/StellenanzeigeCreate
 * @version 0.0.1
 */
class StellenanzeigeCreate {
  /**
   * Constructs a new <code>StellenanzeigeCreate</code>.
   * @alias module:model/StellenanzeigeCreate
   * @param titel {String} 
   * @param beschreibung {String} 
   * @param ende {Date} 
   */
  constructor(titel, beschreibung, ende) {
    StellenanzeigeCreate.initialize(this, titel, beschreibung, ende);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, titel, beschreibung, ende) {
    obj['titel'] = titel;
    obj['beschreibung'] = beschreibung;
    obj['ende'] = ende;
  }

  /**
   * Constructs a <code>StellenanzeigeCreate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StellenanzeigeCreate} obj Optional instance to populate.
   * @return {module:model/StellenanzeigeCreate} The populated <code>StellenanzeigeCreate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new StellenanzeigeCreate();
      if (data.hasOwnProperty('titel')) {
        obj['titel'] = _ApiClient.default.convertToType(data['titel'], 'String');
      }
      if (data.hasOwnProperty('beschreibung')) {
        obj['beschreibung'] = _ApiClient.default.convertToType(data['beschreibung'], 'String');
      }
      if (data.hasOwnProperty('ende')) {
        obj['ende'] = _ApiClient.default.convertToType(data['ende'], 'Date');
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('datei')) {
        obj['datei'] = _DateiBase.default.constructFromObject(data['datei']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>StellenanzeigeCreate</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>StellenanzeigeCreate</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of StellenanzeigeCreate.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['titel'] && !(typeof data['titel'] === 'string' || data['titel'] instanceof String)) {
      throw new Error("Expected the field `titel` to be a primitive type in the JSON string but got " + data['titel']);
    }
    // ensure the json data is a string
    if (data['beschreibung'] && !(typeof data['beschreibung'] === 'string' || data['beschreibung'] instanceof String)) {
      throw new Error("Expected the field `beschreibung` to be a primitive type in the JSON string but got " + data['beschreibung']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    // validate the optional field `datei`
    if (data['datei']) {
      // data not null
      _DateiBase.default.validateJSON(data['datei']);
    }
    return true;
  }
}
StellenanzeigeCreate.RequiredProperties = ["titel", "beschreibung", "ende"];

/**
 * @member {String} titel
 */
StellenanzeigeCreate.prototype['titel'] = undefined;

/**
 * @member {String} beschreibung
 */
StellenanzeigeCreate.prototype['beschreibung'] = undefined;

/**
 * @member {Date} ende
 */
StellenanzeigeCreate.prototype['ende'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
StellenanzeigeCreate.prototype['bild'] = undefined;

/**
 * @member {module:model/DateiBase} datei
 */
StellenanzeigeCreate.prototype['datei'] = undefined;
var _default = exports.default = StellenanzeigeCreate;